import { api } from '@config/api';
import type {
  Cidade,
  CorpoResposta,
  Estado,
  MinhaParticipacao,
  Pais,
  RespostaSalvaResultado,
} from '../types/Formulario';

export const formularioService = {
  campanhaAtiva: () =>
    api
      .get<{ campanha: { id: string; nome: string } | null }>('/campanhas/ativa')
      .then((r) => r.data.campanha),
  participacao: (id: string) =>
    api.get<MinhaParticipacao>(`/campanhas/${id}/minha-participacao`).then((r) => r.data),
  responder: (id: string, corpo: CorpoResposta) =>
    api.put<RespostaSalvaResultado>(`/campanhas/${id}/minha-resposta`, corpo).then((r) => r.data),
  paises: () => api.get<Pais[]>('/axiis/paises').then((r) => r.data),
  estados: () => api.get<Estado[]>('/axiis/estados').then((r) => r.data),
  cidades: (estadoId: number) =>
    api.get<Cidade[]>(`/axiis/estados/${estadoId}/cidades`).then((r) => r.data),
};
